import { Compass, Map, Sparkles } from "lucide-react";
import { SignupForm } from "./SignupForm";

export function FunnelHero({ onSignupComplete }: { onSignupComplete: () => void }) {
  return (
    <>
            <section className="mx-auto flex min-h-[calc(100svh-80px)] w-full max-w-6xl flex-col justify-center px-5 pb-16 pt-8 sm:px-8 sm:pb-24 sm:pt-16 lg:min-h-[calc(100svh-104px)] lg:flex-row lg:items-center lg:gap-16">
              <div className="max-w-3xl flex-1">
                <p className="mb-5 text-xs font-bold uppercase tracking-[0.24em] text-funnel-muted">A better way to arrive</p>
                <h1 className="max-w-3xl text-[clamp(2.75rem,10vw,6.75rem)] font-bold leading-[0.98] tracking-[-0.06em] text-funnel-sand">
                  Land in a foreign country already knowing seven people
                </h1>
                <p className="mt-7 max-w-xl text-lg leading-8 text-funnel-muted sm:text-xl">
                  Start by telling us how you like to travel. We’ll use it to help you discover better trips, events, and ideas.
                </p>
              </div>
              <div className="mt-10 w-full max-w-xl shrink-0 lg:mt-0 lg:max-w-md">
                <SignupForm onComplete={onSignupComplete} />
                <p className="mt-4 text-center text-xs leading-5 text-funnel-muted sm:text-left">
                  No spam. Just a faster path to travel ideas that feel like you.
                </p>
              </div>
            </section>
            <section className="border-t border-funnel-sand/10 bg-funnel-sand text-funnel-ink">
              <div className="mx-auto grid w-full max-w-6xl gap-12 px-5 py-20 sm:px-8 sm:py-28 lg:grid-cols-2 lg:gap-24">
                <div>
                  <p className="mb-5 text-xs font-bold uppercase tracking-[0.24em] text-funnel-muted">Make it yours</p>
                  <h2 className="max-w-xl text-3xl font-bold leading-tight tracking-[-0.04em] sm:text-5xl">
                    A few preferences make the possibilities feel less overwhelming.
                  </h2>
                </div>
                <div className="flex flex-col justify-end">
                  <p className="max-w-md text-xl font-semibold leading-8 sm:text-2xl">
                    Choose your style, pace, comfort level, and the things you love to do.
                  </p>
                  <p className="mt-7 max-w-md text-base leading-7 text-funnel-muted">
                    Then explore what’s already happening or make a trip of your own with AI.
                  </p>
                </div>
              </div>
            </section>
    </>
  );
}

const HOW_IT_WORKS_STEPS = [
  { icon: Compass, number: "01", text: "Set the travel preferences that matter to you." },
  { icon: Map, number: "02", text: "Explore experiences and trips that spark an idea." },
  { icon: Sparkles, number: "03", text: "Build your own trip with AI when you’re ready." },
];

export function FunnelHowItWorks() {
  return (
          <section className="mx-auto w-full max-w-6xl px-5 py-20 sm:px-8 sm:py-28" id="funnel-how-it-works">
            <p className="mb-5 text-xs font-bold uppercase tracking-[0.24em] text-funnel-muted">How it works</p>
            <h2 className="max-w-xl text-3xl font-bold leading-tight tracking-[-0.04em] sm:text-5xl">A more personal way to plan</h2>
            <div className="mt-12 grid gap-4 md:grid-cols-3">
              {HOW_IT_WORKS_STEPS.map(({ icon: Icon, number, text }) => (
                <article key={number} className="rounded-2xl bg-funnel-sand p-6 text-funnel-ink sm:p-8">
                  <div className="flex items-center justify-between">
                    <Icon className="h-6 w-6" strokeWidth={1.7} aria-hidden="true" />
                    <span className="text-xs font-bold tracking-[0.2em] text-funnel-muted">{number}</span>
                  </div>
                  <p className="mt-14 text-lg font-semibold leading-7">{text}</p>
                </article>
              ))}
            </div>
          </section>
  );
}
